import React, { useEffect, useState } from "react";
import eventBus from "src/utils/eventBus";

const CompleteModal: React.FC = () => {
    const [isHandlingBack, setIsHandlingBack] = useState(false);
    const [type, setType] = useState(null);
    const [isVisible, setIsVisible] = useState(false);


    useEffect(() => {
        const onShowcomplete = (data: { type: "success" }) => {
            setType(data.type);
            setTimeout(() => setIsVisible(true), 10);
            if (window.history.state !== "modal-open") {
                window.history.pushState("modal-open", "", window.location.pathname);
            }
        };

        eventBus.on("completeModal:show", onShowcomplete);

        return () => {
            eventBus.off("completeModal:show", onShowcomplete);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = "hidden";

            const handleBackButton = () => {
                if (!isVisible || isHandlingBack) return;

                setIsHandlingBack(true);
                closeModal();

                setTimeout(() => setIsHandlingBack(false), 200);
            };

            window.addEventListener("popstate", handleBackButton);

            return () => {
                document.body.style.overflow = "auto";
                window.removeEventListener("popstate", handleBackButton);
                setIsHandlingBack(false);
            };
        }
    }, [isVisible, isHandlingBack]);

    const closeModal = () => {
        setIsVisible(false); 
        setTimeout(() => setType(null), 300);
    };

    if (!type) return null;

    return (
        <>
            <div className={`overlay ${isVisible ? "active" : ""}`} onClick={closeModal}></div>
            <div className={`modal fade ${isVisible ? "show" : ""} d-block`} tabIndex={-1} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-4 text-center" style={{ borderRadius: "8px" }}>
                        <div className="modal-body">
                            <h4 className="fw-bold mb-3">등록 완료</h4>
                            <p className="text-muted">등록이 완료되었습니다. 감사합니다.</p>
                        </div>
                        <div className="modal-footer border-0">
                            <button type="button" className="btn btn-dark w-100 pt-3 pb-3" onClick={closeModal}>확인</button>
                        </div>                
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompleteModal;